"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["webkit", "moz", "ms", "o", ""];
//# sourceMappingURL=vendors.js.map